export default __webpack_public_path__ + "static/media/CV-Kaustubh-Padwal.24f719a9.pdf";